import { render, staticRenderFns } from "./CompAddContract.vue?vue&type=template&id=07ce8854&"
import script from "./CompAddContract.vue?vue&type=script&lang=js&"
export * from "./CompAddContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports